const Select = {
  sizes: {
    md: {
      field: {
        fontSize: "12px",
        lineHeight: "24px",
        fontWeight: "400",
      },
    },
  },
};

export default Select;
